import makeRequest, { axiosInstance } from './makeRequest';
// Exporting all available methods through the request object
// eslint-disable-next-line no-restricted-syntax
export default {
    get: makeRequest({ method: 'get' }),
    patch: makeRequest({ method: 'patch' }),
    post: makeRequest({ method: 'post' }),
    delete: makeRequest({ method: 'delete' }),
    put: makeRequest({ method: 'put' }),
    axiosInstance,
};
//# sourceMappingURL=index.js.map